<div class="modal active">
  <div class="modal__container modal__container--sm" style="max-width: 550px;">
    <div class="fields">
      <h2>Add Sectorization</h2>
      <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  class="active" #form="ngForm">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="input-fields">
                <div>
                    <label for="sectType">Type</label>
                    <div>
                      <select id="sectType" [(ngModel)]="sectorization.type" name="sectType" required>
                        <option *ngFor="let type of Object.keys(DeviceSectorizationType);"
                                [value]="type">{{type}}</option>
                      </select>
                    </div>
                </div>
                <div>
                  <label for="">Power</label>
                  <div class="coordenates">
                    <input name="power_dBW" type="number" required [(ngModel)]="sectorization.power.dBW"/>
                    <span>[dBW]</span>
                    <input name="power_dBm" type="number" required [(ngModel)]="sectorization.power.dBm"/>
                    <span>[dBm]</span>
                      <!--              <span class="error" *ngIf="!docValid">The Doc value should be defined between 1 and 160 NM.
                                                    </span></div>-->
                  </div>
                </div>
                <div>
                  <label for="">Gain</label>
                  <div class="coordenates">
                    <input name="gain" type="number" required [(ngModel)]="sectorization.gain"/>
                    <span>[dBi]</span>
                    <!--              <span class="error" *ngIf="!docValid">The Doc value should be defined between 1 and 160 NM.
                                                  </span></div>-->
                  </div>
                </div>
                <div>
                  <label for="">Min Azimuth </label>
                  <div class="coordenates">
                    <input #minAz type="number" required="true" name="minazimuth" [(ngModel)]="sectorization.minAngle"/>
                    <span>[deg]</span>
                  </div>
                </div>
                <div>
                  <label for="">Max Azimuth </label>
                  <div class="coordenates">
                    <input #maxAz type="number" name="maxazimuth" required="true" [(ngModel)]="sectorization.maxAngle"/>
                    <span>[deg]</span>
                    <span class="error" *ngIf="minAz.value < -360 || minAz.value > 360 || minAz.value < -360 || minAz.value > 360">
                      The Azimuth Angles should be between -360 and 360.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="form.form.valid ? 'blue' : 'gray'"
                    (click)="add();" [disabled]="!form.form.valid">Add</button>
            <a class="gray" href="#" type="reset" value="Cancel" (click)="cancel()">Cancel</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
